export default __webpack_public_path__ + "static/media/class_vii_viii_ix.ab29d1e7.png";